import { createApp } from 'vue/dist/vue.esm-bundler';

import { beforeMountVueApps, i18n } from './vue-shared';

import BYOS from './BYOS.vue';
import byosStore from './store/byos';

function mountVueApps() {
    if (window.vueCurrentActiveStates.byos) {
        const byos = createApp(BYOS);
        byos.use(i18n).use(byosStore);
        byos.mount('#byosVue');
    }
}

beforeMountVueApps(mountVueApps);
